import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons'
import { LoadScript, Marker, GoogleMap } from "@react-google-maps/api"
import Modal from './Modal'

const googleMapsApiKey = 'AIzaSyB1nIgZ3jE9Vn7bdZu5r8lZ5Yhwryf-ZY0'
const containerStyle = {
  height: '50vh',
  width:'100%'
};
 
/*
 loadingElement: <div style={{ height: `100%` }} />,
      containerElement: <div style={{ height: `200px` }} />,
      mapElement: <div style={{ height: `100%` }} />,
    })
*/

const MyMapComponent = (props) =>
      <LoadScript
      loadingElement={<div style={{ height: `100%` }} />}
      googleMapsApiKey={googleMapsApiKey}
    >
    <GoogleMap
      mapContainerStyle={containerStyle}
      zoom={8}
      center={{ lat: parseFloat(props.latitude), lng: parseFloat(props.longitude) }}
    >
      {props.isMarkerShown && <Marker position={{ lat: parseFloat(props.latitude), lng: parseFloat(props.longitude) }} onClick={props.onMarkerClick} />}
    </GoogleMap>
    </LoadScript>

function Location(props) {
    const [modal, setModal] = useState(false)
    const { latitude, longitude } = props.step

    return <li className="d-flex flex-column beigeListItem pb-2 w-50">
        <div className="d-flex flex-column" onClick={() => setModal(!modal)}> 
            <div className="beigeListIcon d-flex justify-content-center align-items-center">
            <FontAwesomeIcon icon={faMapMarkerAlt} />
            </div>
            <div className="beigeListInfo pl-2">
            <h3 className="beigelistTitle mb-0">Location</h3>
            </div>
        </div>
        {modal && <div className="map">
        {latitude && longitude ? 
        <Modal title="Map View" modal={modal} toggleModal={setModal}><MyMapComponent isMarkerShown={true} latitude={latitude} longitude={longitude} /></Modal> : "No Co-ordinates"}
        </div>}
    </li>
}


export default Location